import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';

function formatPhoneNumber(value) {
  let digits = value.replace(/\D/g, '');
  let hasCountryCode = false;
  if (digits.startsWith('1') && digits.length > 10) {
    hasCountryCode = true;
    digits = digits.slice(1);
  }
  if (digits.length === 0) return hasCountryCode ? '+1 ' : '';
  if (digits.length <= 3) return (hasCountryCode ? '+1 ' : '') + `${digits}`;
  if (digits.length <= 6) return (hasCountryCode ? '+1 ' : '') + `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return (hasCountryCode ? '+1 ' : '') + `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}

function validatePhoneNumber(value) {
  // Accepts (xxx)-xxx-xxxx or +1 (xxx)-xxx-xxxx
  let digits = value.replace(/\D/g, '');
  if (digits.startsWith('1') && digits.length === 11) {
    digits = digits.slice(1);
  }
  return /^\d{10}$/.test(digits);
}

const USPhoneInput = ({ value, onChange, disabled, label, InputProps, inputProps, className, size = 'small', showLabel = true, id }) => {
  const [touched, setTouched] = useState(false);

  return (
    <FormControl fullWidth>
      {showLabel && label && (
        <label htmlFor={id} style={{ marginBottom: 4, fontWeight: 500 }}>
          {label}
        </label>
      )}
      <TextField
        id={id}
        variant="outlined"
        size={size}
        value={formatPhoneNumber(value || '')}
        onChange={(e) => {
          let raw = e.target.value.replace(/\D/g, '');
          // Allow user to type +1 or 1 as country code
          if (raw.startsWith('1') && raw.length > 10) {
            raw = '1' + raw.slice(1, 11); // Only allow 1 + 10 digits
          } else {
            raw = raw.slice(0, 10);
          }
          onChange(raw);
          if (touched) setTouched(false); // Reset error on change
        }}
        onBlur={() => setTouched(true)}
        disabled={disabled}
        InputProps={InputProps}
        inputProps={{ maxLength: 17, ...inputProps }}
        className={className}
        error={touched && value && !validatePhoneNumber(value)}
        helperText={touched && value && !validatePhoneNumber(value) ? 'Invalid Phone number' : ''}
      />
    </FormControl>
  );
};

USPhoneInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  InputProps: PropTypes.object,
  inputProps: PropTypes.object,
  className: PropTypes.string,
  size: PropTypes.string,
  showLabel: PropTypes.bool,
  id: PropTypes.string,
};

USPhoneInput.defaultProps = {
  showLabel: true,
};

export default USPhoneInput;
